module.exports = __webpack_public_path__ + "static/media/glass-war-lambo.7b1e54e1.png";